import React, { useState, useEffect } from 'react';
import Iframe from 'react-iframe';
import { Modal } from 'react-bootstrap';
import PlayOrSkip from './gamePlay.js';
import submitButton from './images/submit-entry-button.png';
import config from '../../../promotion_config';

export const EntryForm = ({
    promotion_id,
    promotion,
    appUrl,
    createfunc,
    drawTicket,
    entry,
    game,
    actions,
    getGame,
}) => {
    const formUrl = appUrl + '/entry.php';

    const initialState = {
        ticket1_1_1: '',
        entry_method: '',
        form_submitted: '1',
        'entry-submit': 'SUBMIT+ENTRY',
        promotion: promotion,
    };

    const [formState, setFormState] = useState(initialState);
    const [disabled, setDisabled] = useState(false);
    const [showRevealModal, setShowRevealModal] = useState(false);
    const [revealUrl, setRevealUrl] = useState('');

    useEffect(() => {
        setGameUrl(game.game);
    }, [game]);

    useEffect(() => {
        clearIfSuccess();
    }, [drawTicket]);

    const handleRevealClose = () => {
        setShowRevealModal(false);
        setRevealUrl('');
        window.removeEventListener('message', handleMessage, false);
    };

    const handleMessage = event => {
        if (event.data.callback === 'closeModal') {
            handleRevealClose();
        }
    };

    //* Interactive Game section
    const [gameUrl, setGameUrl] = useState(null);

    const setGamePlayed = async gameurl => {
        await actions.gameActions.setEntryFlashGameFlag({
            entry_id: entry.last_entry ? entry.last_entry.id : 0,
            promotion: config.promotion,
            flag: 2,
            game_id: config.promotion_id,
        });
        navigate(gameurl);
    };

    const setGameSkipped = async () => {
        await actions.gameActions.reset();
        await actions.drawTicketActions.reset();
        await setGameUrl(null);
    };

    useEffect(() => {
        setGameUrl(game.game);
    }, [game]);
    //* END Interactive Game section

    // fire the submission
    const handleSubmit = async event => {
        setDisabled(true);
        event.preventDefault();

        await createfunc(formState);

        setDisabled(false);
        document.getElementById('entry-alert').scrollIntoView(true);
    };

    const convertAlphaNumeric = str => {
        return str.replace(/[^a-z0-9]/gi, '');
    };

    // if the form field changes, we will change the value in the store and
    // also check if the next field must be focused
    const handleChange = function(event) {
        const target = event.target;
        const value =
            target.type === 'checkbox'
                ? target.checked
                : convertAlphaNumeric(target.value.toUpperCase());
        const name = target.name;

        setFormState({ ...formState, [name]: value });

        autotab(target, target.dataset.next);
    };

    // if the form submit was a success, we clear the form
    const clearIfSuccess = async () => {
        if (drawTicket.success) {
            setFormState(initialState);
            await actions.entryActions.getEntries();

            if (
                entry.last_entry &&
                entry.last_entry.points > -1 &&
                entry.last_entry.prize_id > -1
            ) {
                window.addEventListener('message', handleMessage, false);
                const mapping = {
                    ticketsEntered: entry.last_entry.showcase_entry_count ?? '',
                    entryValue: entry.last_entry.points ?? '',
                    bonusEntries: entry.last_entry.bonus_points ?? '',
                };

                const outcomeData = { outcome: btoa(JSON.stringify(mapping)) };
                actions.gameActions.getGame(outcomeData);
            }
        }
    };

    // rehash of old autotab functionality from PA
    const autotab = (current, nex) => {
        var next = document.getElementById(nex);

        if (
            !!nex &&
            !!current &&
            current.getAttribute &&
            current.value.length === parseInt(current.getAttribute('maxlength'))
        ) {
            next.focus();
        }
    };

    const modalStyles = {
        background: 'rgba(0, 0, 0, .6)',
        display: 'flex',
    };

    return (
        <div id="form-target" className="entry-form">
            <form
                name="ticket_entry"
                id="ticket_entry"
                action={formUrl}
                disabled={disabled}
                method="post"
                encType="application/x-www-form-urlencoded"
                onSubmit={handleSubmit}
            >
                <div className="flush-row entry-fields">
                    <div>
                        <label
                            htmlFor="ticket1_1_1"
                            className="input-label"
                            style={{ color: '#8A0940' }}
                        >
                            WEB CODE ON FRONT
                        </label>
                    </div>
                    <div className="col">
                        <div className="form-group">
                            <input
                                type="text"
                                name="ticket1_1_1"
                                id="ticket1_1_1"
                                title="Integer Value"
                                value={formState.ticket1_1_1}
                                onChange={handleChange}
                                size="10"
                                maxLength="10"
                                className="form-control entry-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="instructions">
                    <p>
                        (Scroll further down on this page for more
                        instructions.)
                    </p>
                </div>
                <div className="flush-row">
                    <div className="col-sm-8 col-sm-offset-2">
                        <input
                            id="entry-submit"
                            type="image"
                            name="submit"
                            className="img-responsive center-block entry-submit"
                            alt="Submit Entry"
                            src={submitButton}
                        />
                    </div>
                </div>
                <input
                    type="hidden"
                    id="entry_method"
                    name="entry_method"
                    value={formState.entry_method}
                />
                <input
                    type="hidden"
                    id="form_submitted"
                    name="form_submitted: '1'"
                    value={formState.form_submitted}
                />
            </form>

            <PlayOrSkip
                game_url={gameUrl}
                skip_url="#"
                showModal={gameUrl ? true : false}
                onGamePlayed={setGamePlayed}
                closeModal={setGameSkipped}
                entry={entry}
            />

            <div
                className={`modal ${showRevealModal ? 'in' : ''} reveal-modal`}
                style={showRevealModal ? modalStyles : { display: 'none' }}
            >
                <Modal.Dialog>
                    <Modal.Header>
                        <button
                            className="btn-close close"
                            aria-label="Close"
                            onClick={handleRevealClose}
                        >
                            X
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <Iframe
                            id="reveal-animation"
                            className="reveal-animation"
                            display="initial"
                            position="relative"
                            url={revealUrl}
                        />
                    </Modal.Body>
                </Modal.Dialog>
            </div>
        </div>
    );
};

export default EntryForm;
